import { Navigate, Route, Routes } from 'react-router-dom';

import { useFeatureFlag } from 'utils/featureFlagging/useFeatureFlag';

import { SettingsIntegrationsCardsShopifyCreateView } from './views/create';
import { SettingsIntegrationsCardsShopifyEditView } from './views/edit';
import { SettingsIntegrationsCardsShopifyTestView } from './views/test';

export const SettingsIntegrationsCardsShopifyRoutes = (): JSX.Element => {
  const { ecosystemLegacyShopifyCardCreation } = useFeatureFlag([
    'ecosystem-legacy-shopify-card-creation',
  ]);

  return (
    <Routes>
      <Route
        path="edit/:id"
        element={<SettingsIntegrationsCardsShopifyEditView />}
      />

      {ecosystemLegacyShopifyCardCreation && (
        <Route
          path="create"
          element={<SettingsIntegrationsCardsShopifyCreateView />}
        />
      )}

      <Route
        path="test/:id"
        element={<SettingsIntegrationsCardsShopifyTestView />}
      />

      <Route path="*" element={<Navigate to="/settings/integrations" />} />
    </Routes>
  );
};

export const settingsIntegrationsCardsShopifyRoutes = (
  <Route
    path="shopify-card/*"
    element={<SettingsIntegrationsCardsShopifyRoutes />}
  />
);
